import NavBarWithFooterLayout from "../../layouts/navBarWithFooter.layout";
import Page from "./page.models.page";

const ModelLayout = () => {
  return (
    <NavBarWithFooterLayout>
      <Page />
    </NavBarWithFooterLayout>
  );
};

export default ModelLayout;
